// import { videoList } from '@/mocks/videoList.dev.js';  // 請根據實際路徑進行調整
// import { videoList } from '@/mocks/videoList.prod.js';  // 請根據實際路徑進行調整

const videoListModule = require(`@/mocks/${process.env.VUE_APP_MOCK_FILE}.js`);
const videoList = videoListModule.videoList;
// const videoList = require(`@/mocks/${process.env.VUE_APP_MOCK_FILE}.js`);

const getVideos = () => {
  return new Promise((resolve) => {

    console.log(videoList);
    // 模擬網絡延遲
    setTimeout(() => {
      resolve(videoList);
    }, 10);  // 500ms 的延遲，可以根據需要調整
  });
};

export default {
  getVideos
};
